import { render, staticRenderFns } from "./SystemPermissionGroupManageBySystem.vue?vue&type=template&id=42e2aa32&scoped=true"
import script from "./SystemPermissionGroupManageBySystem.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupManageBySystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2aa32",
  null
  
)

export default component.exports